import React from "react";
import {ListItem, Paragraph, SectionHeading} from "../PrivacyPolicyText";

const InformationProvidedSection = () => (
  <>
    <SectionHeading>{"Information You Provide to Us."}</SectionHeading>

    <Paragraph>{"The information We collect on or through our Website and Applications may include:"}</Paragraph>

    <ListItem>
      {"Information that you provide by filling in forms. This includes information provided at the time of registering to use our Services or Challenges, subscribing to our service, or requesting further services. We may also ask you for information when you report a problem with our Website, Applications, or other platforms."}
    </ListItem>

    <ListItem>{"Information that you provide Us or to establish an account."}</ListItem>

    <ListItem>
      {"Records and copies of your correspondence (including email addresses), if you contact Us or provide Us with feedback."}
    </ListItem>

    <ListItem withBottomMargin>
      {"Details of transactions you carry out through our Services and of the fulfillment of your participation in any Services."}
    </ListItem>

    <Paragraph>
      {"You also may provide information to be published or displayed (hereinafter, \"posted\") on public areas of the Website, Applications, or other platform, or transmitted to other users of the Website or third parties (collectively, \"User Contributions\"). Your User Contributions are posted on and transmitted to others at your own risk. Please be aware that no security measures are perfect or impenetrable. Additionally, We cannot control the actions of other users of the Website, Applications, or other platform with whom you may choose to share your User Contributions. Therefore, We cannot and do not guarantee that your User Contributions will not be viewed by unauthorized persons."}
    </Paragraph>
  </>
);

export default InformationProvidedSection;
